<template>
  <div class="link" :class="{ 'link--bordered': bordered }">
    <nuxt-link :to="url" :target="target ? target : ''">{{ title }}</nuxt-link>
  </div>
</template>

<script>
export default {
  name: "RelatedLink",
  props: {
    title: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: "",
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    target: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.link {
  font-size: 1.4rem;
  line-height: 1.9rem;
  font-weight: bold;
  padding: 0 1rem 1.3rem 0;
  display: inline-block;
  margin-bottom: 1.3rem;
  border-bottom: 1px dashed #b1b3b3;
  width: 100%;

  &--bordered {
    border: 1px solid #c6d5e0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem 0;
  }

  &:not(:last-child) {
    margin-right: 0.4rem;
  }

  &:last-of-type {
    margin-right: 0;
    border-bottom: none;
  }

  a {
    color: $text_gray;
    text-decoration: none;

    &:hover {
      color: $text_gray;
    }
  }
}
</style>
